(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/assets/javascripts/views/system-rows-container.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/assets/javascripts/views/system-rows-container.js');

'use strict';

svs.keno.components.play.views.SystemRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardSettingsRegion: '#boardSettingsRegion',
    boardContainerRegion: '#boardContainerRegion',
    rowsRegion: '#rowsRegion',
    campaignCardRegion: '#campaignCardRegion'
  },
  template(data) {
    return svs.keno.components.play.templates.system_row_container(data);
  },
  onRender() {
    this.showChildView('boardSettingsRegion', new svs.keno.components.play.views.BoardSettings({
      model: this.model,
      collapsedToggleWidth: 250
    }));
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      boardButtonsView: svs.numbergames.game.views.BoardButtonsSystem,
      className: 'board-container-keno col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-1 col-lg-5 col-lg-offset-2'
    }));
    this.showChildView('rowsRegion', new svs.numbergames.game.views.SystemSummary({
      model: this.model,
      className: 'number-games-system-summary-keno',
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 150
    }));
    this.showChildView('campaignCardRegion', new svs.numbergames.game.views.CampaignCard({
      model: this.model,
      className: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-1 col-lg-5 col-lg-offset-2'
    }));
  }
});

 })(window);